import store from '@/store/store'

//var serviceName = 'userService'
var path = 'api/Portal/'
//var isDebug = false

const adminRoles = [
    'Administrator'
]

const verificationRoles = [
    'Birth Verification',
    'Death Verification',
    'Death Insurance Verification',
    'Marriage Verification',
    'Divorce Verification',
    'Administrator'
]

const birthVerificationRoles = [
    'Birth Verification',
    'Administrator'
]

const deathVerificationRoles = [
    'Death Verification',
    'Death Insurance Verification',
    'Administrator'
]

const marriageVerificationRoles = [
    'Marriage Verification',
    'Administrator'
]

const divorceVerificationRoles = [
    'Divorce Verification',
    'Administrator'
]

const publicRoles = [
    'Public',
    'Administrator'
]

const patAffRequestorRoles = [
    'Paternity Affidavit Requestor',
    'Administrator'
]

const deathInsuranceRoles = [
    'Death Insurance Verification'
]

// const Roles = [
//     'Administrator',
//     'Public',
//     'Verification'
// ]

// check if user's roleList matches any of the checkRoleList
function hasRoleCheck (checkRoleList) {
    let vssUserDto = store.state.auth.vssUserDto || {}
    let userRoleList = vssUserDto.roleList
    if (userRoleList) {
        var checkRoleListUpper = checkRoleList.map(role => role.toUpperCase())
        return userRoleList.some(role => {
            return checkRoleListUpper.includes(role.toUpperCase())
        })
    } else {
        return false
    }
}

// function hasRole (role) {
//     return hasRoleCheck([role])
// }

function isAdministrator () {
    return hasRoleCheck(adminRoles)
}

function isVerificationUser () {
    return hasRoleCheck(verificationRoles)
}

function isBirthVerificationUser () {
    return hasRoleCheck(birthVerificationRoles)
}

function isDeathVerificationUser () {
    return hasRoleCheck(deathVerificationRoles)
}

function isMarriageVerificationUser () {
    return hasRoleCheck(marriageVerificationRoles)
}

function isDivorceVerificationUser () {
    return hasRoleCheck(divorceVerificationRoles)
}

function isPublicUser () {
    return hasRoleCheck(publicRoles)
}

function isPatAffReqUser () {
    return hasRoleCheck(patAffRequestorRoles)
}

function isDeathInsuranceUser () {
    return hasRoleCheck(deathInsuranceRoles)
}

function hasRoleList () {
    let vssUserDto = store.state.auth.vssUserDto || {}
    return !!vssUserDto.roleList && vssUserDto.roleList.length > 0
}

function getCurrentPortalUser (http) {
    //loggingService.log(isDebug, serviceName, 'getCurrentPortalUser')
    return http.get(path + 'getCurrentPortalUser')
}

function getPortalUser (http, portalUserId) {
    return http.get(path + 'GetPortalUser?portalUserId=' + portalUserId)
}

function listUserResultDtos (http) {
    //loggingService.log(isDebug, serviceName, 'listUserResultDtos')
    return http.get(path + 'ListUserResultDtos')
}

function listActiveUserResultDtos (http) {
    //loggingService.log(isDebug, serviceName, 'listActiveUserResultDtos')
    return http.get(path + 'ListActiveUserResultDtos')
}

function searchNewUsers (http, showInactive) {
    //loggingService.log(isDebug, serviceName, 'searchNewUsers')
    return http.get(path + 'SearchNewUsers?showInactive=' + showInactive)
}

function saveUser (http, userDto) {
    //loggingService.log(isDebug, serviceName, 'put')
    return http.put(path + 'SaveUser', userDto)
}

function setUserInactive (http, portalUserId) {
    //loggingService.log(isDebug, serviceName, 'put')
    return http.put(path + 'SetUserInactive?portalUserId=' + portalUserId)
}

function setUserActive (http, portalUserId) {
    //loggingService.log(isDebug, serviceName, 'put')
    return http.put(path + 'SetUserActive?portalUserId=' + portalUserId)
}

function searchUsers (http, searchDto) {
    return http.post(path + 'SearchUsers', searchDto)
}

function searchNonPublicUsers (http, searchDto) { // make sure to also return agency info with user info
    return http.post(path + 'SearchNonPublicUsers', searchDto)
}

function getCurrentPortalUserAgency (http) {
    return http.get(path + 'GetCurrentPortalUserAgency')
}

function getUserAgency (http, portalUserId) {
    return http.get(path + 'GetUserAgency?portalUserId=' + portalUserId)
}

function addAgencyToCurrentUser (http, insertDto) {
    return http.post(path + 'AddAgencyToCurrentUser', insertDto)
}

function updateUserAgency (http, insertDto) {
    return http.post(path + 'UpdateuserAgency', insertDto)
}

function userUpdateSelf (http, firstName, lastName) {
    return http.post(path + 'UserUpdateSelf', { firstName, lastName })
}

export default {
    getCurrentPortalUser: getCurrentPortalUser,
    getPortalUser: getPortalUser,
    isAdministrator: isAdministrator,
    hasRoleList: hasRoleList,
    isVerificationUser: isVerificationUser,
    isBirthVerificationUser: isBirthVerificationUser,
    isDeathVerificationUser: isDeathVerificationUser,
    isMarriageVerificationUser: isMarriageVerificationUser,
    isDivorceVerificationUser: isDivorceVerificationUser,
    isPublicUser: isPublicUser,
    isPatAffReqUser: isPatAffReqUser,
    isDeathInsuranceUser: isDeathInsuranceUser,
    listUserResultDtos: listUserResultDtos,
    listActiveUserResultDtos: listActiveUserResultDtos,
    searchNewUsers: searchNewUsers,
    saveUser: saveUser,
    setUserInactive: setUserInactive,
    setUserActive: setUserActive,
    searchUsers: searchUsers,
    getCurrentPortalUserAgency: getCurrentPortalUserAgency,
    getUserAgency: getUserAgency,
    addAgencyToCurrentUser: addAgencyToCurrentUser,
    updateUserAgency: updateUserAgency,
    userUpdateSelf: userUpdateSelf,
    searchNonPublicUsers: searchNonPublicUsers
}
